import { useCallback, useRef } from 'react';

/**
 * Defers a menu item's action until the menu has closed, for actions that
 * take focus themselves (starting an inline rename). Radix hands focus back
 * to the trigger as the menu closes, which would steal it from the input the
 * action just focused; running the action from `onCloseAutoFocus` and
 * preventing that default keeps the focus where the action put it.
 */
export function useAfterMenuClose() {
  const pendingRef = useRef<(() => void) | null>(null);

  const runAfterClose = useCallback((action: () => void) => {
    pendingRef.current = action;
  }, []);

  const onCloseAutoFocus = useCallback((event: Event) => {
    const action = pendingRef.current;
    if (!action) return;
    pendingRef.current = null;
    event.preventDefault();
    action();
  }, []);

  return { runAfterClose, onCloseAutoFocus };
}
